export default __webpack_public_path__ + "static/media/nginx.63e0789f.svg";